import axiosInstance from  "../../axiosInstance";
import {dispatchError, dispatchSuccess, loadingDispatch} from "../../DispatchFunctions"
import { ERROR_GET_COMPLAINTS_LIST, ERROR_GET_NATURE_OF_FAULTS, ERROR_POST_COMPLAINTS, LOADING_GET_COMPLAINTS_LIST, LOADING_GET_NATURE_OF_FAULTS, LOADING_POST_COMPLAINTS, SUCCESS_GET_COMPLAINTS_LIST, SUCCESS_GET_NATURE_OF_FAULTS, SUCCESS_POST_COMPLAINTS } from "../../Types";
import { createFaultReques, getComplaintsListUrl, getNatureOfFaultsUrl } from "../../URL";

export function getUserComplaintsList(telephoneNo){
    let url = getComplaintsListUrl + 'faultyTelephoneNo=' + telephoneNo
    return (dispatch) => {
       dispatch(loadingDispatch(LOADING_GET_COMPLAINTS_LIST)) 
       axiosInstance.get(url).then((response) => {
           if(response.status === 200 && response.data.isSuccess){

                dispatch(dispatchSuccess(SUCCESS_GET_COMPLAINTS_LIST, response.data.dataBundle))
           }else{

                dispatch(dispatchError(ERROR_GET_COMPLAINTS_LIST, response.error.errorShow))
           } 
            
       }).catch((error) => {
        dispatch(dispatchError(ERROR_GET_COMPLAINTS_LIST, 'erross'))
       })
    }
  
}

export function getNatureOfFaults(accessName, serviceName) {
    //encodeURIComponent(accessName)
    const url = getNatureOfFaultsUrl + 'access_name=' + encodeURIComponent(accessName) + '&service_name=' + encodeURIComponent(serviceName);
    return (dispatch) => {
        dispatch(loadingDispatch(LOADING_GET_NATURE_OF_FAULTS));
        axiosInstance.get(url).then((response) => {
            if (response.status === 200 && response.data.isSuccess && response.data.dataBundle && response.data.dataBundle.data) {
                dispatch(dispatchSuccess(SUCCESS_GET_NATURE_OF_FAULTS, response.data.dataBundle.data));
            } else {
                dispatch(dispatchError(ERROR_GET_NATURE_OF_FAULTS, response.data?.errorShow || 'Failed to load complaint types'));
            }
        }).catch((error) => {
            dispatch(dispatchError(ERROR_GET_NATURE_OF_FAULTS, error?.message || 'Failed to load complaint types'));
        });
    };
}

export function createUserComplaint(telephoneNo, serviceID, serviceOption, contactNo, faultdescription, lattitude, longitude, status, natureOfFault){
    let url = createFaultReques + 'faultyTelephoneNo=' + telephoneNo + '&serviceOption=' + serviceOption + '&contactNo='+  contactNo +'&faultdescription='+ encodeURIComponent(faultdescription) +'&lattitude='+ lattitude +'&longitude=' + longitude + '&status=' + status + '&serviceID=' + serviceID;
    if (natureOfFault) {
        url += '&natureOfFault=' + encodeURIComponent(natureOfFault);
    }
    return(dispatch) => {
        dispatch(loadingDispatch(LOADING_POST_COMPLAINTS))
        axiosInstance.post(url).then((response) => {
            if(response.status === 200 && response.data.isSuccess){

                dispatch(dispatchSuccess(SUCCESS_POST_COMPLAINTS, response.data.dataBundle))
                // dispatch(loadingDispatch(LOADING_GET_COMPLAINTS_LIST)) 
            }else{

                dispatch(dispatchError(ERROR_POST_COMPLAINTS, response.data.errorShow))
                dispatch(loadingDispatch(LOADING_GET_COMPLAINTS_LIST)) 
            }
        }).catch((error) => {
            dispatch(dispatchError(ERROR_POST_COMPLAINTS, 'errorPost'))
            // dispatch(loadingDispatch(LOADING_GET_COMPLAINTS_LIST)) 
        })
    }
}